














































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getdatalist, addExpert, updateExpert, deleteExpert, uploadFile, getExpertInfo } from '@/api/expertTank'
import { uploadzsxg } from '@/api/declare'
@Component({
  name: 'expertTank'
})
export default class extends Vue {

  mounted() {
    this.getTableList(this.listQuery)
    this.baseUrl = (window as any).baseurl
    this.grouplist = require('./../../../public/group.json')
  }
  private baseUrl = ''
  private loadingfile = false
  private listQuery = {
    code: '',
    pageNum: 1,
    pageSize: 10
  }
  private addParams:any = {
    name: '', // 姓名
    sex: 0, // 0男1女2
    typeofcertificate: '', // 专家证件类型
    idnumber: '', // 证件号码
    hometown: '', // 籍贯
    dateofbirth: '', // 出生日期
    nationality: '', // 民族
    politicalstatus: '', // 政治面貌
    jobtitle: '', // 职务
    title: '', // 职称
    email: '', // 电子邮箱
    phone: '', // 手机号码
    department: '', // 科室
    officephone: '', // 办公电话
    employer: '', // 工作单位
    area: '', // 地区
    postalcode: '', // 邮政编码
    mailingaddress: '', // 通讯地址
    bachelorofscience: '', // 学位
    profession: '', // 专业
    graduatedschool: '', // 毕业院校
    nowengagedinprofessional: '', // 现从事专业
    isexaminationrules: '', // 是否接受中心命审题培训
    iscandidateexam: '', // 是否参与社会或机构培训
    bankaccount: '', // 开户银行
    banknumber: '', // 银行卡号
    remarks: '', // 备注
    nameofkeydiscipline: '', // 重点学科
    nameofkeyspecialty: '', // 重点专科
    keysubjectlevel: '', // 重点学科级别
    keyspecialistlevel: '', // 重点专科级别
    keydisciplineapprovalunit: '', // 重点学科审批单位
    keyspecialtyapprovalunit: '', // 重点专科审批单位
    subjectleader: '', // 学科带头人
    academicleader: '', // 学术带头人
    tutor: '', // 研究生导师
    subject: '', // 所属学科
    subjectstobeundertaken: '', // 拟承担科目
    unitopinion: '', // 单位意见
    mainworkingexperience: '', // 主要工作经历
    scientificresearchachievementsandawards: '', // 科研结果及获奖情况
    createTime: '' // 创建日期
  }
  private grouplist = []
  private expertId:any = ''
  // 校验规则
  private rules = {
    name: [
      { required: true, message: '请输入专家名称', trigger: 'blur' }
    ],
    sex: [
      { required: true, message: '请选择专家性别', trigger: 'change' }
    ],
    typeofcertificate: [
      { required: true, message: '请选择证件类型', trigger: 'change' }
    ],
    idnumber: [
      { required: true, message: '请输入证件号码', trigger: 'blur' }
    ],
    jobtitle: [
      { required: true, message: '请输入职务', trigger: 'blur' }
    ],
    jobtitlesimple: [
      { required: true, message: '请输入职称', trigger: 'blur' }
    ],
    email: [
      { required: true, message: '请输入邮箱地址', trigger: 'blur' },
      { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
    ],
    phone: [
      { required: true, message: '请输入手机号码', trigger: 'blur' },
      {
        pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
        message: '手机号码格式有误！',
        trigger: 'blur'
      }
    ],
    employer: [
      { required: true, message: '请输入工作单位', trigger: 'blur' }
    ],
    nowengagedinprofessional: [
      { required: true, message: '请输入现从事专业', trigger: 'blur' }
    ]
  }
  private papersTypeList = [
    {
      label: '身份证',
      value: '身份证'
    }
  ]
  private title = ''
  private isloading = false
  private total = 0
  private currtentpage = 1
  private dialogVisible = false // 新增专家dialog
  private diaFile = false
  private dataList = [] // 列表数据源
  private multipleSelection = [] // 复选数据
  private idList:any = [] // 批量删除的专家idlist
  private fileList:any = [] // 导入的fileList
  // 复选框事件
  handleSelectionChange(val) {
    this.multipleSelection = val
    this.multipleSelection.forEach((res:any) => {
      this.idList.push(res.id)
    })
  }
  private getTableList(val) {
    this.isloading = true
    getdatalist(val).then((res) => {
      if (res.code === 200) {
        this.isloading = false
        this.dataList = res.data.records
        this.total = res.data.total
      }
    })
  }
  // 分页
  handleSizeChange(val) {
    this.listQuery.pageSize = val
    this.getTableList(this.listQuery)
  }
  handleCurrentChange(val) {
    this.listQuery.pageNum = val
    this.getTableList(this.listQuery)
  }
  handleClose() {
    this.dialogVisible = false
  }
  handleCloseFile() {
    this.diaFile = false
  }
  // 打开dialog
  showDia() {
    this.title = '新增专家库'
    this.expertId = ''
    this.$nextTick(() => {
      (this.$refs.ruleForm as any).resetFields()
      this.addParams = {
        name: '', // 姓名
        sex: '1' , // 男1女2
        typeofcertificate: '', // 专家证件类型
        idnumber: '', // 证件号码
        hometown: '', // 籍贯
        dateofbirth: '', // 出生日期
        nationality: '', // 民族
        politicalstatus: '', // 政治面貌
        jobtitle: '', // 职务
        title: '', // 职称
        email: '', // 电子邮箱
        phone: '', // 手机号码
        department: '', // 科室
        officephone: '', // 办公电话
        employer: '', // 工作单位
        area: '', // 地区
        postalcode: '', // 邮政编码
        mailingaddress: '', // 通讯地址
        bachelorofscience: '', // 学位
        profession: '', // 专业
        graduatedschool: '', // 毕业院校
        nowengagedinprofessional: '', // 现从事专业
        isexaminationrules: '', // 是否接受中心命审题培训
        iscandidateexam: '', // 是否参与社会或机构培训
        bankaccount: '', // 开户银行
        banknumber: '', // 银行卡号
        remarks: '', // 备注
        nameofkeydiscipline: '', // 重点学科
        nameofkeyspecialty: '', // 重点专科
        keysubjectlevel: '', // 重点学科级别
        keyspecialistlevel: '', // 重点专科级别
        keydisciplineapprovalunit: '', // 重点学科审批单位
        keyspecialtyapprovalunit: '', // 重点专科审批单位
        subjectleader: '', // 学科带头人
        academicleader: '', // 学术带头人
        tutor: '', // 研究生导师
        subject: '', // 所属学科
        subjectstobeundertaken: '', // 拟承担科目
        unitopinion: '', // 单位意见
        mainworkingexperience: '', // 主要工作经历
        scientificresearchachievementsandawards: '', // 科研结果及获奖情况
        createTime: '' // 创建日期
      }
    })
    this.dialogVisible = true
  }
  // 下载模板
  downloadPdf() {
    let href = this.baseUrl + '/expertlibrary/download'
    const savea = document.createElement('a')
    // savea.download = "已填写的申报内容";
    savea.href = href
    savea.click()
  }
  // 查询数据
  searchData() {
    this.getTableList(this.listQuery)
  }
  // 清空查询数据
  clearSearch() {
    this.getTableList(this.listQuery)
  }
  // 批量删除数据
  removeData() {
    if (this.idList.length === 0) {
      this.$message.warning('当前未选中数据')
    } else {
      this.$confirm('确定将删除选中的专家, 是否确定?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let param = {
          ids: this.idList
        }
        deleteExpert(param).then((res) => {
          if (res.code === 200) {
            this.getTableList(this.listQuery)
            this.$message.success('数据删除成功')
          } else if (res.code !== 200) {
            this.$message.warning(res.message)
          }
        })
      })
    }
  }
  // 编辑数据
  editData(val) {
    this.title = '编辑专家库'
    this.dialogVisible = true
    this.$nextTick(() => {
      (this.$refs.ruleForm as any).resetFields()
      this.expertId = val.id
      let param = {
        id: val.id
      }
      getExpertInfo(param).then((res) => {
        if (res.code === 200) {
          this.addParams = res.data
          console.log('参数设置', this.addParams)
        }
      })
    })
  }
  // 提交数据
  submitData() {
    const form = this.$refs.ruleForm as any
    form.validate((valid: boolean) => {
      if (valid) {
        if (this.expertId === '') {
          this.addParams.idnumber = Number(this.addParams.idnumber)
          addExpert(this.addParams).then((res) => {
            if (res.code === 200) {
              this.$message.success('数据添加成功')
              this.dialogVisible = false
              this.getTableList(this.listQuery)
            }
          })
        } else {
          let params = {
            name: this.addParams.name, // 姓名
            sex: this.addParams.sex, // 男1女2
            typeofcertificate: this.addParams.typeofcertificate, // 专家证件类型
            idnumber: Number(this.addParams.idnumber), // 证件号码
            hometown: this.addParams.hometown, // 籍贯
            dateofbirth: this.addParams.dateofbirth, // 出生日期
            nationality: this.addParams.nationality, // 民族
            politicalstatus: this.addParams.politicalstatus, // 政治面貌
            jobtitle: this.addParams.jobtitle, // 职务
            jobtitlesimple: this.addParams.jobtitlesimple, // 职称
            email: this.addParams.email, // 电子邮箱
            phone: this.addParams.phone, // 手机号码
            department: this.addParams.department, // 科室
            officephone: this.addParams.officephone, // 办公电话
            employer: this.addParams.employer, // 工作单位
            area: this.addParams.area, // 地区
            postalcode: this.addParams.postalcode, // 邮政编码
            mailingaddress: this.addParams.mailingaddress, // 通讯地址
            bachelorofscience: this.addParams.bachelorofscience, // 学位
            profession: this.addParams.profession, // 专业
            graduatedschool: this.addParams.graduatedschool, // 毕业院校
            nowengagedinprofessional: this.addParams.nowengagedinprofessional, // 现从事专业
            isexaminationrules: this.addParams.isexaminationrules, // 是否接受中心命审题培训
            iscandidateexam: this.addParams.iscandidateexam, // 是否参与社会或机构培训
            bankaccount: this.addParams.bankaccount, // 开户银行
            banknumber: this.addParams.banknumber, // 银行卡号
            remarks: this.addParams.remarks, // 备注
            nameofkeydiscipline: this.addParams.nameofkeydiscipline, // 重点学科
            nameofkeyspecialty: this.addParams.nameofkeyspecialty, // 重点专科
            keysubjectlevel: this.addParams.keysubjectlevel, // 重点学科级别
            keyspecialistlevel: this.addParams.keyspecialistlevel, // 重点专科级别
            keydisciplineapprovalunit: this.addParams.keydisciplineapprovalunit, // 重点学科审批单位
            keyspecialtyapprovalunit: this.addParams.keyspecialtyapprovalunit, // 重点专科审批单位
            subjectleader: this.addParams.subjectleader, // 学科带头人
            academicleader: this.addParams.academicleader, // 学术带头人
            tutor: this.addParams.tutor, // 研究生导师
            subject: this.addParams.subject, // 所属学科
            subjectstobeundertaken: this.addParams.subjectstobeundertaken, // 拟承担科目
            unitopinion: this.addParams.unitopinion, // 单位意见
            mainworkingexperience: this.addParams.mainworkingexperience, // 主要工作经历
            scientificresearchachievementsandawards: this.addParams.scientificresearchachievementsandawards, // 科研结果及获奖情况
            createTime: this.addParams.createTime, // 创建日期
            id: this.expertId,
            isdelete: 0
          }
          updateExpert(params).then((res) => {
            if (res.code === 200) {
              this.$message.success('数据更改成功')
              this.dialogVisible = false
              this.getTableList(this.listQuery)
            }
          })
        }
      }
    })
  }
  // 打开上传文件页面
  showFileDia() {
    this.diaFile = true
    this.fileList = []
  }
  topicfilechange(file) {
    this.fileList.push(file)
  }
  // 上传数据
  uploadFile() {
    if (this.fileList.length === 0) {
      this.$message.warning('当前未选择数据')
    } else {
      let formdata:any = new FormData()
      this.fileList.forEach((res:any) => {
        formdata.append('file', res.raw)
      })
      this.loadingfile = true
      uploadFile(formdata).then((res) => {
        if (res.code === 200) {
          this.$message.success('专家表上传成功')
          this.diaFile = false
          this.loadingfile = false
          this.getTableList(this.listQuery)
        } else {
          this.$message.warning(res.message)
          this.loadingfile = false
        }
      })
    }
  }
  fileBeforeRemove(file: any, fileList: any) {
    this.fileList = fileList
  }
}
